import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import getMultiFilters from 'modules/core/components/MultiFilters/hooks/utils/getMultiFilters'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import asyncAction, { isSuccessful } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import {
  formatCustomFilters,
  getCustomFilters,
} from 'modules/shift_management/components/ShiftManagement/Content/_filters/customFilters'
import CopyShiftModal from 'modules/shift_management/components/ShiftManagement/CopyShiftModal'
import useApplyFilters from 'modules/shift_management/hooks/useApplyFilters'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import Api from 'modules/shift_management/lib/Api'
import { trackAddShiftStartEvent } from 'modules/shift_management/lib/trackEvents'

interface Props {
  disabled?: boolean
}
const CopyShiftButton = ({ disabled }: Props) => {
  const [showModal, setShowModal] = React.useState<boolean>(false)
  const [shiftsCount, setShiftsCount] = React.useState<number>(0)
  const [restDaysCount, setRestDaysCount] = React.useState<number>(0)
  const onClose = () => setShowModal(false)
  const [{ shiftsRows }] = useShiftsRows()
  const [{ view }] = useSchedule()

  const { getFilteredEmployees } = useApplyFilters(shiftsRows)

  const { running: submitting, performAction: onClick } = useAsyncAction(
    async () => {
      const employeeIds = getFilteredEmployees().map((e) => e.id)

      const { filters: multiFilters, logicOperator } = getMultiFilters(
        LOCAL_STORAGE_KEYS.shiftEmployees
      )

      const customFilters = getCustomFilters(multiFilters)

      const result = await asyncAction(
        () =>
          Api.fetchCopyScheduleStats(view.previousPeriod.startAt, {
            employee_ids: employeeIds,
            logic_operator: logicOperator.get('logic_operator').value,
            custom_filters: formatCustomFilters(customFilters),
          }),
        {
          successFlash: false,
          errorFlash: true,
        }
      )

      if (isSuccessful(result)) {
        const { value } = result
        setShiftsCount(value.shifts_count)
        setRestDaysCount(value.rest_days_count)
        setShowModal(true)
        trackAddShiftStartEvent({
          view,
          impactedEmployees: employeeIds.length,
          cellCount: value.employees_count,
          shiftType: 'copyPeriod',
          from: 'top_bar',
        })
      }
    },
    {
      successFlash: false,
      errorFlash: false,
    }
  )

  return (
    <>
      {showModal && (
        <CopyShiftModal onClose={onClose} shiftsCount={shiftsCount} restDaysCount={restDaysCount} />
      )}
      <Button
        type="secondary"
        onClick={onClick}
        disabled={submitting || disabled}
        iconName="layers-front"
      >
        {i18n.t('shift_management.actions.copy_shift')}
      </Button>
    </>
  )
}

export default CopyShiftButton
